import * as _ from 'lodash';
import {CHOOSE_DECREASE_POWER_SOURCE_HINT, CHOOSE_GENERAL_HINT, CHOOSE_INCREASE_POWER_SOURCE_HINT} from "../actions/action";
import {put, select, takeEvery} from "redux-saga/effects";
import {AnyAction} from "redux";
import {getEnergyMix, getPowerSourceDifferenceRatios} from "../reducers/getEnergyMix";
import {getCostPerMw} from "../reducers/outputs/costPerMw";
import {getEnergyOutput} from "../reducers/outputs/energyOutput";
import {getEnvironmentalImpact} from "../reducers/outputs/environmentalImpact";
import {showHint} from "../actions/hints";
import {getHints, IEnergyMixDictionary, IHint} from "../../data/data";

/**
 * handle hints
 */
export default function* handleHints()
{
    // yield takeEvery(CHOOSE_GENERAL_HINT, onRequestGeneralHint);
    // yield takeEvery(CHOOSE_INCREASE_POWER_SOURCE_HINT, onRequestIncreasePowerSourceHint);
    // yield takeEvery(CHOOSE_DECREASE_POWER_SOURCE_HINT, onRequestDecreasePowerSourceHint);
}


/**
 * choose a suitable hint based on game properties
 * @param {AnyAction} action
 */
function* onRequestGeneralHint(action: AnyAction)
{
    // //  get KPIs
    //
    // const energy_mix: number = yield select(getEnergyMix);
    // const cost_per_mw: number = yield select(getCostPerMw);
    // const energy_output: number = yield select(getEnergyOutput);
    // const environmental: number = yield select(getEnvironmentalImpact);
    //
    // const kpis = {energy_mix, cost_per_mw, energy_output, environmental};
    //
    // //  get all hints
    //
    // const hints: IHint[] = getHints();
    //
    // // console.group('onRequestHint');
    // // console.log('energy_mix', energy_mix);
    // // console.log('cost_efficiency', cost_efficiency);
    // // console.log('energy_output', energy_output);
    // // console.log('environmental', environmental);
    // // console.log('hints', hints);
    //
    // //  find the first hint whose requirements fit the current game state
    //
    // // const relevant_hints: IHint[] = _.filter(hints, hint =>
    // // {
    // //     return _.every(hint.requirements, (range: number[], kpi: string) =>
    // //     {
    // //         const kpi_value: number = kpis[kpi];
    // //h
    // //         return kpi_value >= range[0] && kpi_value <= range[1];
    // //     })
    // // });
    // //
    // // // console.log('relevant_hints', relevant_hints);
    // //
    // // const hint: IHint = _.sample(relevant_hints);
    // const hint: IHint = _.sample(hints);
    //
    // // console.log('hint', hint);
    // // console.groupEnd();
    //
    // if (! hint) return;
    //
    // //  add more score
    //
    // yield put(showHint(hint.id));
}


/**
 * choose a suitable hint based on game properties
 * @param {AnyAction} action
 */
function* onRequestIncreasePowerSourceHint(action: AnyAction)
{
    // //  get the dictionary of power source ratios
    //
    // const ratios: IEnergyMixDictionary = yield(select(getPowerSourceDifferenceRatios));
    //
    // const {[0]:id} = _.minBy(_.toPairs(ratios), ratio => _.last(ratio));
    //
    // console.log('lowest ratiod ID is', id);
}


/**
 * choose a suitable hint based on game properties
 * @param {AnyAction} action
 */
function* onRequestDecreasePowerSourceHint(action: AnyAction)
{
    // //  get KPIs
    //
    // const energy_mix: number = yield select(getEnergyMix);
    // const cost_per_mw: number = yield select(getCostPerMw);
    // const energy_output: number = yield select(getEnergyOutput);
    // const environmental: number = yield select(getEnvironmentalImpact);
    //
    // const kpis = {energy_mix, cost_per_mw, energy_output, environmental};
    //
    // //  get all hints
    //
    // const hints: IHint[] = getHints();
    //
    // // console.group('onRequestHint');
    // // console.log('energy_mix', energy_mix);
    // // console.log('cost_efficiency', cost_efficiency);
    // // console.log('energy_output', energy_output);
    // // console.log('environmental', environmental);
    // // console.log('hints', hints);
    //
    // //  find the first hint whose requirements fit the current game state
    //
    // const relevant_hints: IHint[] = _.filter(hints, hint =>
    // {
    //     return _.every(hint.requirements, (range: number[], kpi: string) =>
    //     {
    //         const kpi_value: number = kpis[kpi];
    //
    //         return kpi_value >= range[0] && kpi_value <= range[1];
    //     })
    // });
    //
    // // console.log('relevant_hints', relevant_hints);
    //
    // const hint: IHint = _.sample(relevant_hints);
    //
    // // console.log('hint', hint);
    // // console.groupEnd();
    //
    // if (! hint) return;
    //
    // //  add more score
    //
    // yield put(showHint(hint.id));
}



// WEBPACK FOOTER //
// ./src/ts/store/sagas/handleHints.ts